import type { ReceiptTemplate } from '../schema';

export const chatgptTemplate: ReceiptTemplate = {
  id: 'chatgpt',
  name: 'ChatGPT Receipt',
  brand: 'OPENAI',
  description: 'ChatGPT Plus subscription receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'gpt-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'OPENAI',
        businessNameFontSize: 20,
        addressLines: ['CHATGPT PLUS', 'PAYMENT RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'gpt-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'invoice', label: 'Invoice:', value: 'GPT-847291034' },
          { id: 'account', label: 'Account:', value: 'john@email.com' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'type', label: 'Type:', value: 'Monthly' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'gpt-plan',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'PLAN: ChatGPT Plus\nBILLING: Monthly Subscription\nNEXT BILLING: 02/04/2026', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'gpt-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'sub', label: 'CHATGPT PLUS', value: '20.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '1.65', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '21.65', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'gpt-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'gpt-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'PAYMENT SUCCESSFUL\n\nTHANK YOU', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

